<div class="d-flex flex-column dl-application">
  <main class="d-flex flex-row flex-grow-1">
    <div class="flex-grow-1 dl-content">
      <router-outlet></router-outlet>
    </div>
  </main>
</div>